import { render, staticRenderFns } from "./escalationrules.vue?vue&type=template&id=4e789a60&lang=pug"
import script from "./escalationrules.vue?vue&type=script&lang=js"
export * from "./escalationrules.vue?vue&type=script&lang=js"
import style0 from "./escalationrules.vue?vue&type=style&index=0&id=4e789a60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports